import { render, staticRenderFns } from "./MerchantKycUpdateStatusModal.vue?vue&type=template&id=5203a0ef&scoped=true"
import script from "./MerchantKycUpdateStatusModal.vue?vue&type=script&lang=js"
export * from "./MerchantKycUpdateStatusModal.vue?vue&type=script&lang=js"
import style0 from "./MerchantKycUpdateStatusModal.vue?vue&type=style&index=0&id=5203a0ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5203a0ef",
  null
  
)

export default component.exports